import {
  AppstoreOutlined,
  FileAddOutlined,
  QuestionCircleOutlined,
  UnorderedListOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { Button, Col, Radio, Row, Space, Tooltip, Typography } from 'antd';
import { FC } from 'react';
import { useFilesGalleryViewType, useSetFilesGalleryViewType } from '../../../store/files-gallery.store';
import styles from './GalleryComponents.module.scss';

export interface GalleryFilesHeaderProps {
  openFilePicker: (item: boolean) => void;
  hasFiles: boolean;
  tooltip?: string;
  disabled?: boolean;
}

const GalleryFilesHeader: FC<GalleryFilesHeaderProps> = ({ openFilePicker, hasFiles, tooltip, disabled }) => {
  const { Title } = Typography;

  const setFilesGalleryViewType = useSetFilesGalleryViewType();
  const filesGalleryViewType = useFilesGalleryViewType();

  return (
    <Row gutter={[8, 8]} justify="space-between">
      <Col>
        <Space className={styles.firstSection}>
          <FileAddOutlined />
          <Title level={5} className="filesText" style={{ margin: 0 }}>
            Files
          </Title>
        </Space>
        <Radio.Group
          defaultValue={filesGalleryViewType}
          size="small"
          onChange={(e) => setFilesGalleryViewType(e.target.value)}
        >
          <Radio.Button value="cards" title="Cards view">
            <AppstoreOutlined />
          </Radio.Button>
          <Radio.Button value="list" title="List view">
            <UnorderedListOutlined />
          </Radio.Button>
        </Radio.Group>
        {tooltip && (
          <Tooltip title={tooltip}>
            <QuestionCircleOutlined className={styles.tooltipFileIcon} />
          </Tooltip>
        )}
      </Col>
      <Col>
        <Button disabled={disabled} onClick={() => openFilePicker(true)} icon={<UploadOutlined />}>
          {hasFiles ? 'Select files' : 'Add files'}
        </Button>
      </Col>
    </Row>
  );
};

export default GalleryFilesHeader;
